'use es6';

import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { fromJS, List } from 'immutable';
import indexBy from 'transmute/indexBy';
import get from 'transmute/get';
const formatEmailSubscriptionRecord = subscription => {
  return new ReferenceRecord({
    description: subscription.description,
    id: `${subscription.id}`,
    label: subscription.name,
    referencedObject: fromJS(subscription)
  });
};
const formatEmailSubscriptions = response => indexBy(get('id'), List(response).map(formatEmailSubscriptionRecord));
export default formatEmailSubscriptions;